import store from "@/store";
import * as types from "@/store/constants/types";
import Http from "@/api/http/fetch/index";
import localStorageHelper from "@/localstorage/localstorage";
import EventBus from "@/utils/eventBus";
import { sendEvent } from "@/utils/analytics";
import { routerStackModule } from "@/utils/routerStackUtil";

const routerPushOrReplace = (name: any, data: any) => {
  const routerStack = routerStackModule.routerStack[0];
  if (routerStack && routerStack.name === name) {
    store.dispatch(types.ROUTER_REPLACE, data);
  } else {
    store.dispatch(types.ROUTER_PUSH, data);
  }
};

const handleNoticeRouterPush = (data: any) => {
  console.log("点击通知获取的data", data);
  if (
    data.type &&
    (data.type === "order_finished" || data.type === "daily_subs")
  ) {
    const { transaction_id } = data;
    const findOffer = store.getters[types.GETTER_PURCHASED_OFFER].find(
      (offer: any) => {
        return offer.transaction_id === transaction_id;
      }
    );
    if (findOffer) {
      // EventBus.$emit("show-delivered-dialog", findOffer);
      // const userList: any = store.state.userList;
      //
      // if (findOffer.resource && findOffer.resource.user_id && userList && userList.find((v: any) => v.userId.toString() === findOffer.resource.user_id)) {
      //   store.dispatch(types.UPDATE_USER_INS_INFO, {
      //     userId: findOffer.resource.user_id,
      //     username: findOffer.resource.userName
      //   });
      //   store.dispatch(types.UPDATE_USER_INS_POST, findOffer.resource.userId);
      // }
      try {
        EventBus.$emit("show-delivered-dialog", findOffer);
        const userList: any = store.getters[types.GETTER_USER_LIST];

        console.log("findOffer:", findOffer);
        if (
          findOffer.resource &&
          findOffer.resource.user_id &&
          findOffer.resource.username &&
          userList &&
          userList.length > 0 &&
          userList.find(
            (v: any) =>
              v.userId &&
              v.userId.toString() === findOffer.resource.user_id.toString()
          )
        ) {
          store.dispatch(types.UPDATE_USER_INS_INFO, {
            userId: Number(findOffer.resource.user_id),
            username: findOffer.resource.username
          });
          store.dispatch(
            types.UPDATE_USER_INS_POST,
            Number(findOffer.resource.user_id)
          );
        }
      } catch (e) {}
    }
  } else if (data.type && data.type === "offerwall") {
    //积分墙和视屏的的推送：(增加了金币)
    //直接更新masterserveData用来刷新金币
    store.dispatch(types.UPDATE_GX_MASTER_SERVER_DATA);
    // _this.updateMasterServerData();
    const { reward } = data;
    if (reward) {
      EventBus.$emit("toast-show", {
        type: "get-coins",
        way: "watchad",
        coins: reward,
        duration: 3000
      });
    }
  } else if (data.type && data.type === "checkin") {
    EventBus.$emit("check-in-show");
  } else if (data.type && data.type === "open_web") {
    if (data.hasOwnProperty("url") && data.url.length > 0) {
      Http.StartNewWebInstance(data.url);
    }
  } else if (data.type && data.type === "orderProcessNotice") {
    localStorage.setItem("getRouter", "Order");
    store.dispatch(types.ROUTER_PUSH, {
      name: "Order",
      params: {
        routerTransition: "forward"
      }
    });
  } else if (data.type && data.type === "sepcial-follow-notice") {
    routerPushOrReplace("Followers", {
      name: "Followers",
      params: {
        routerTransition: "forward",
        comeFromNotice: true,
        noticeType: data.type
      }
    });
    sendEvent("uia_push_sku_show", "special_followers");
  } else if (data.type && data.type === "sepcial-like-notice") {
    routerPushOrReplace("Posts", {
      name: "Posts",
      params: {
        routerTransition: "forward",
        comeFromNotice: true,
        noticeType: data.type
      }
    });
    sendEvent("uia_push_sku_show", "special_likes");
  } else if (
    (data.type &&
      (data.type === "vip-free-trail-notice" ||
        data.type === "vip-will-expire-notice" ||
        data.type === "call-back-to-vip-notice")) ||
    data.type === "vip-expired-notice"
  ) {
    const index = data.index ? data.index : "slide0";
    routerPushOrReplace("VipCenter", {
      name: "VipCenter",
      params: {
        routerTransition: "up",
        type: "single",
        noticeType: data.type
      },
      query: {
        type: "single",
        sildeIndex: index
      }
    });
    if (data.type === "call-back-to-vip-notice") {
      sendEvent("uia_push_free_VIP_click");
    } else if (data.type === "vip-free-trail-notice") {
      sendEvent("uia_push_first_vip_show");
    } else if (data.type === "vip-expired-notice") {
      sendEvent("uia_push_vip_expired_renew_show");
    } else if (data.type === "vip-will-expire-notice") {
      sendEvent("uia_push_vip_noexpired_renew_show");
    }
  } else if (data.type && data.type === "vip-package-notice") {
    routerPushOrReplace("VIPDiscount", {
      name: "VIPDiscount",
      params: {
        routerTransition: "up",
        noticeType: data.type
      }
    });
    sendEvent("uia_push_sku_show", "Vippackage");
  } else if (data.type && data.type === "lucky-coin-notice") {
    EventBus.$emit("show-lucky-toast", true);
    sendEvent("uia_push_sku_show", "lucky_coins");
  } else if (data.type && data.type === "limit-coin-notice") {
    EventBus.$emit("show-limit-coin", true);
    sendEvent("uia_push_sku_show", "limit-coins");
  } else if (data.type && data.type === "earn-coin-notice") {
    routerPushOrReplace("EarnCoin", {
      name: "EarnCoin",
      params: {
        noticeType: data.type
      }
    });
    sendEvent("uia_push_earn_coins_click");
  } else if (data.type && data.type === "call-back-notice") {
    routerPushOrReplace("Followers", {
      name: "Followers",
      params: {
        routerTransition: "forward",
        comeFromNotice: false //不用强制显示special offer
      }
    });
    store.commit(types.LITE_SEARCH_POP_SHOW, true);
    sendEvent("uia_push_no_account_click");
  } else if (data.type && data.type === "sub-follow-notice") {
    routerPushOrReplace("SubsFollower", {
      name: "SubsFollower",
      params: {
        scrollPos: data.scrollPos,
        comeFromNotice: true
      }
    });
    sendEvent("uia_push_daily_followers_show");
  } else if (data.type && data.type === "sub-like-notice") {
    routerPushOrReplace("SubsLikes", {
      name: "SubsLikes",
      params: {
        scrollPos: data.scrollPos,
        comeFromNotice: true
      }
    });
    sendEvent("uia_push_auto_likes_show");
  } else if (data.type && data.type === "casino-notice") {
    routerPushOrReplace("Casino", {
      name: "Casino",
      params: {
        routerTransition: "up",
        game: "spin"
      }
    });
    if (data.isplay === "notplay") {
      sendEvent("uia_push_1st_casino_show");
    } else if (data.isplay === "lesscoin") {
      sendEvent("uia_push_Scoins_casino_show");
    } else if (data.isplay === "morecoin") {
      sendEvent("uia_push_Bcoins_casino_show");
    }

    //记录点击赌场通知的时间
    localStorageHelper.set("click_casino-notice-time", new Date().getTime());
  } else if (data && data.type === "double_coin") {
    routerPushOrReplace("DoubleCoinSplash", {
      name: "DoubleCoinSplash",
      params: {
        routerTransition: "up"
      }
    });
  } else if (data && data.type === "half_coin") {
    routerPushOrReplace("HalfCoinsSplash", {
      name: "HalfCoinsSplash",
      params: {
        routerTransition: "up"
      }
    });
  } else if (data && data.type === "newbie_finished") {
    console.log("newbie_finished", data);
    const findOffer = {
      resource: {
        image_low: data.image || data.url
      },
      kind: "free_follow",
      effect: data.finish_number || data.reward,
      type: data.type
    };
    EventBus.$emit("show-delivered-dialog", findOffer);
    const currentUserInfo = store.getters[types.GETTER_CURRENT_INS_USER_INFO];
    if (currentUserInfo && currentUserInfo.userId) {
      store.dispatch(types.UPDATE_USER_INS_INFO, {
        userId: currentUserInfo.userId,
        username: currentUserInfo.userName
      });
      store.dispatch(types.UPDATE_USER_INS_POST, currentUserInfo.userId);
    }
    sendEvent("uia_free_follow_arrive_page_show");
  }
};

export default handleNoticeRouterPush;
